/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Integrations_Tool_Count_OneInputs */



/**
* | output |
* | --- |
* | "{count} tool" |
*
* @param {Integrations_Tool_Count_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_tool_count_one = /** @type {((inputs: Integrations_Tool_Count_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Tool_Count_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Werkzeug`)
	return /** @type {LocalizedString} */ (`${i?.count} tool`)
});